/* eslint-disable */
/* tslint:disable */

export interface CityDto {
  name: string;
  code: string;
  zones?: ZoneDto[];
}

export interface ZoneDto {
  name: string;
  code: string;
  type: ZoneType;
  cityCode: string;
}

export enum ZoneType {
  PARKING = 'PARKING',
  PUBLIC_TRANSPORT = 'PUBLIC_TRANSPORT',
}

export interface HighwaySectionDto {
  code: string;
  highwayName: string;
  sectionName: string;
}

export enum InvoiceType {
  INVOICE = 'INVOICE',
  NOTE = 'NOTE',
}
